import { palette } from 'src/styles/colors';
import styled, { css } from 'styled-components';

export const ResourceCenterMobileMenuContainer = styled.div`
  height: 100vh;
  width: calc(100vw - 4rem);
  position: fixed;
  z-index: 13;
  left: 0px;
  top: 0px;
  transition: transform ease-in-out .3s;
  background-color: ${palette.lightSierraRain};
  overflow: auto;
`

export const ResouceCenterMobileMenuOverlay = styled.div<{ opened: boolean }>`
  z-index: 12;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(23,30,40,.5);
  transition: opacity ease-in-out .3s;

  ${({ opened }) =>
    opened ?
      css`
      opacity: 1;
      pointer-events: initial;
    `
      :
      css`
      opacity: 0;
      pointer-events: none;
    `}
`

export const ResourceCenterMobileMenuLinkOverflow = styled.div`
  transition: max-height ease-in-out .3s;
  width: 100%;
  box-sizing: border-box;
  grid-column: 1 / 4;
  overflow: hidden;
  position: relative;
  &:before {
    content: '';
    top: 0px;
    left: 0px;
    position: absolute;
    width: 100%;
    border-top: solid 1px #e5e8ee;
    z-index: 2;
  }

  & > div {
    padding-right: .5rem;
    padding-left: .5rem;
  }
`

export const ResourceCenterMobileMenuLink = styled.div<{ extendable?: boolean, active?: boolean }>`
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: auto 1fr 56px;
  background-color: ${({ active }) => active ? palette.darkerWhite : palette.lightSierraRain};

  a {
    min-height: 43px;
    padding: 9px;
    color: ${palette.text};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3;
    text-decoration: none;
    display: flex;
    align-self: center;
    box-sizing: border-box;
    transition: background-color ease-in-out .3s;

  }

  & > span {
    align-self: center;
    ${({ extendable, active }) => !extendable ?
    css`&:after{ content: ''}` :
    active ?
      css`
        &:after{
          content: '';
          display: block;
          background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNLjEzMiAxMi40NDRMMy44NDggNyAuMTMyIDEuNTU3Qy0uMTQyIDEuMTU1LjAyNS42NDQuNTA0LjQxNWMuNDgtLjIzIDEuMDktLjA5IDEuMzY0LjMxMWw0IDUuODU5YS43Mi43MiAwIDAxMCAuODNsLTQgNS44NTljLS4yNzQuNDAxLS44ODQuNTQtMS4zNjQuMzExLS40OC0uMjI5LS42NDYtLjc0LS4zNzItMS4xNDJ6IiBmaWxsPSIjMkQyNjNCIi8+PC9zdmc+);
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: 6px 14px;
          width: 6px;
          height: 14px;
          margin-left: 20px;
          margin-top: 2px;
          transition: transform .3s;
          transform: rotate(90deg) translateY(5px);
        }`
      :
      css`
        &:after{
          content: '';
          display: block;
          background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNLjEzMiAxMi40NDRMMy44NDggNyAuMTMyIDEuNTU3Qy0uMTQyIDEuMTU1LjAyNS42NDQuNTA0LjQxNWMuNDgtLjIzIDEuMDktLjA5IDEuMzY0LjMxMWw0IDUuODU5YS43Mi43MiAwIDAxMCAuODNsLTQgNS44NTljLS4yNzQuNDAxLS44ODQuNTQtMS4zNjQuMzExLS40OC0uMjI5LS42NDYtLjc0LS4zNzItMS4xNDJ6IiBmaWxsPSIjMkQyNjNCIi8+PC9zdmc+);
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: 6px 14px;
          width: 6px;
          height: 14px;
          margin-left: 20px;
          margin-top: 2px;
          transition: transform .3s;
          transform: rotate(-90deg) translateY(5px);
        }`}
  }
`

export const ResourceCenterMobileMenuPost = styled.div`
  position: relative;
  display: grid;
`

export const ResourceCenterMobileCloseButton = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 999;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${palette.lightSierraRain};
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    line-height: 0px;
  }
`
